import { render, staticRenderFns } from "./CommonFooter.vue?vue&type=template&id=20e402e2&scoped=true"
import script from "./CommonFooter.vue?vue&type=script&lang=js"
export * from "./CommonFooter.vue?vue&type=script&lang=js"
import style0 from "./CommonFooter.vue?vue&type=style&index=0&id=20e402e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e402e2",
  null
  
)

export default component.exports